import '@babel/polyfill';
import 'url-search-params-polyfill';
import 'bootstrap/dist/js/bootstrap';
import './pusher-setup'

import { reportClientError } from 'js/services/Network';
import { configure as mobxConfig } from 'mobx';
import { onError as mobxOnError } from 'mobx-react';
mobxConfig({ enforceActions: 'observed' });
if (window.app.env === 'production') {
  // notify team/slack of errors
  mobxOnError(error =>
    reportClientError({
      error,
      page: AppState.currentPage,
      user_email: AppUser.email,
    }),
  );
} else {
  mobxOnError(console.error);
}

import 'js/services/ServiceWorker';
import './services/ResizeListener';

import React, { Component } from 'react';
import { render } from 'react-dom';
import { Router } from '@reach/router';
import { observer } from 'mobx-react';
import PubSub from 'pubsub-js';

import { navigate } from './services/Network';
import AppState from './stores/AppState';
import AppUser from './stores/AppUser';
import { pagePath, url } from './services/Network';

import AppGrid from './components/AppGrid';
import Header from './components-v2/common/Header/Header';
import InvalidSessionNotice from './components/InvalidSessionNotice';

import Modal from './components/core/Modal';
import LoginSignupDialog from './components/common/LoginSignupDialog';
import PopupTextDisplay from './components/core/PopupTextDisplay';

import NotFoundPage from './components/pages/NotFoundPage';
import AboutUsPage from './components/pages/AboutUsPage';
import TermsAndConditionsPage from './components/pages/TermsAndConditionsPage';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';
import ForgotPasswordPage from './components/pages/ForgotPasswordPage';
import ResetPasswordPage from './components/pages/ResetPasswordPage';
import ChangePasswordPage from './components/pages/ChangePasswordPage';
import MyAccountPage from './components/pages/MyAccountPage';
import EmailPreferencesPage from './components/pages/EmailPreferencesPage';
import LoginPage from './components/pages/LoginPage';
import LogoutPage from './components/pages/LogoutPage';
import SignupPage from './components/pages/SignupPage';
import MarketingPage from './components-v2/pages/MarketingPage';

// Dashboard pages
import AdminDashboardPage from './components/pages/AdminDashboardPage';
// import UserDashboardPage from './components/pages/UserDashboardPage';
import UserDashboardPage from './components-v2/pages/UserDashboard/UserDashboard';
import MyItemsPage from './components/pages/MyItemsPage';
import MyTokensPage from './components/pages/MyTokensPage';

// Item/tokens status page
import StatusPage from './components/pages/StatusPage';

// item/normal sale flow
import CreatePaymentLinkPage from './components/pages/CreatePaymentLinkPage';
import CheckoutPage from './components/pages/CheckoutPage';
import ManageOrderPage from './components/pages/ManageOrderPage';

// token/buyer-first sale flow
import BuyerSignupPage from './components/pages/BuyerSignupPage';
import CreateTokenPage from './components/pages/CreateTokenPage';
import TokenPage from './components/pages/TokenPage';
import TokenConfirmPage from './components/pages/TokenConfirmPage';
import TokenLabelPage from './components/pages/TokenLabelPage';
import ReturnOrderPage from './components/pages/ReturnOrderPage';
import SellerItemsPage from "js/components/pages/MyItemsPage/SellerItemsPage";
import MSellerPage from "js/components-v2/pages/MSellerPage/MSellerPage";
import UploadMultipleItems from "js/components/pages/UploadMultipleItems";
import StoreActivationPage from './components-v2/pages/StoreActivationPage';
import VerificationCodeDialog from './components-v2/common/VerificationCodeDialog/VerificationCodeDialog';
import GokadaStatusPage from 'js/components-v2/pages/GokadaStatusPage';
import TransactionsDashboardPage from 'js/components-v2/pages/UserDashboard/Transactions/TransactionsDashboardPage';
import ManageItemPage from 'js/components/pages/ManageItem';
import SellerLink from 'js/components-v2/pages/SellerLink';
import SPPOnboardLogin from "js/components-v2/pages/SellerPartnershipProgram/onboard/SPPOnboardLogin";
import SPPOnboardPartner from "js/components-v2/pages/SellerPartnershipProgram/onboard/SPPOnboardPartner";
import SPPOnboardSuccess from "js/components-v2/pages/SellerPartnershipProgram/onboard/SPPOnboardSuccess";
import SPPOnboardSignup from "js/components-v2/pages/SellerPartnershipProgram/newUserSignup/SPPOnboardSignup";
import SPPOnboardSignupSuccess from "js/components-v2/pages/SellerPartnershipProgram/newUserSignup/SPPOnboardSignupSuccess";
import LearnMorePage from "js/components-v2/pages/SellerPartnershipProgram/LearnMorePage";
import CreateNewPaymentLinkPage from "js/components-v2/pages/SellerSignup";
import StoreCreatedAddPhone from "js/components-v2/pages/SellerSignup/storeCreatedAddNumber";
import Checkout from "js/components/pages/CheckoutPage/DropOffDetailsV2/BuyerCredit/Checkout";
import ItemsListPage from './components-v2/pages/UserDashboard/Items/ItemsListPage';
import CreateItemPage from './components-v2/pages/UserDashboard/Items/CreateItemPage';
import Welcome from './new/Pages/Welcome';
import Buyer from './new/Pages/Buyer/Index';
import SecurePay from './new/Pages/SecurePay';
import Seller from './new/Pages/Seller/Index';
import BuyerRefPage from "js/components/pages/BuyerLandingPage/BuyerRefPage";
import BuyerPage2 from "js/new/Pages/Buyer/buyer2";
import AboutUs from './new/Pages/AboutUs';
import TermsAndConditions from './new/Pages/TermsAndConditions';
import PrivacyPolicy from './new/Pages/PrivacyPolicy';
import Partnership from './new/Pages/Partnership';
import Help from './new/Pages/Help';
import Referral from './new/Pages/Seller/Referral/Index';
import Complete from './new/Pages/Seller/Referral/Complete';
import Referrals from './new/Pages/Dashboard/Referrals';
import StoreView from './new/Pages/Seller/StoreView';
import Offers from './new/Pages/Dashboard/Offers';
import Earnings from './new/Pages/Dashboard/Earnings';
import PartnerSellerPage from "js/components-v2/pages/SellerPartnershipProgram/PartnerSellerPage";

@observer
class PayOnDelivery extends Component {
  bodyClick = () => PubSub.publish('body-click');
  cancelLogin = () => {
    if (!AppUser.isLoggedIn && AppState.loginRequired) {
      navigate(url('home-page'));
    }
    AppState.hideLoginSignup();
  };

  render() {
    const { loginRequired, loginSignupVisible, msellerLogin, hideLoginSignup, pageColor, invalidSession } = AppState;

    const currentLocation = AppState.currentPage;

    return (
      <>
        <AppGrid color={pageColor} onClick={this.bodyClick}>
          {('UserDashboardPage' !== currentLocation && currentLocation !== 'NEW') ? <Header /> : null}
          <Router>
            <NotFoundPage default />

            {!AppUser.isLoggedIn ? (
              <Welcome path={pagePath('home-page')} />
            ) : AppUser.hasRole('admin') ? (
              <AdminDashboardPage path={pagePath('home-page')} />
            ) : (
              <UserDashboardPage path={pagePath('home-page')} />
            )}

            <MSellerPage path={pagePath('mseller-landing-page')} />
            <MSellerPage path={pagePath('mseller-verify-page')} action="verify" />
            <Buyer path={pagePath('buyer-landing-page')} />
            <BuyerPage2 path={pagePath('buyer-landing-page-two')} />
            <Seller path={pagePath('seller-landing-page')} />
            <SecurePay path={pagePath('securepay-landing-page')} />
            <AboutUs path={pagePath('about-us-page')} />
            <TermsAndConditions path={pagePath('terms-and-conditions-page')} />
            <PrivacyPolicy path={pagePath('privacy-policy-page')} />
            <Partnership path={pagePath('partnership-page')} />
            <Help path={pagePath('help-center-page')} />

            {/* New Add item flow */}
            <ItemsListPage path={pagePath('items.index')} />
            <CreateItemPage path={pagePath('items.create')} />

            <AdminDashboardPage path={pagePath('admin-dashboard-page')} />
            <UserDashboardPage path={pagePath('user-dashboard-page')} />
            <TransactionsDashboardPage path={pagePath('transactions-dashboard-page')} />
            <Offers path={pagePath('offers-dashboard-page')} />
            <Earnings path={pagePath('earnings-dashboard-page')} />
            <MyAccountPage path={pagePath('my-account-page')} />
            <MyItemsPage path={pagePath('my-items-page')} />
            <SellerItemsPage path={pagePath('seller-partner-page')} />
            <MyTokensPage path={pagePath('my-tokens-page')} />
            <StoreActivationPage path={pagePath('store-activation-page')} />

            {/* New Dashboard */}
            <Referrals path={pagePath('referrals-dashboard-page')} />

            <ForgotPasswordPage path={pagePath('forgot-password-page')} />
            <ResetPasswordPage path={pagePath('reset-password-page')} />
            <ChangePasswordPage path={pagePath('change-password-page')} />

            <EmailPreferencesPage path={pagePath('email-preferences-page')} />
            <LoginPage path={pagePath('login-page')} />
            <LoginPage path={pagePath('mkt-login-page')} />
            <LogoutPage path={pagePath('logout-page')} />
            <SignupPage path={pagePath('signup-page')} />
            <MarketingPage path={pagePath('marketing-page')} />

            {/* status page */}
            <StatusPage path={pagePath('status-page')} />
            <GokadaStatusPage path={pagePath('gokada-status-page')} />

            {/* item/normal sale flow */}
            <CreateNewPaymentLinkPage path={pagePath('create-payment-link-page')} />
            <CheckoutPage path={pagePath('checkout-page')} />
            <Checkout path={pagePath('checkout-page-new')} />
            <ManageOrderPage path={pagePath('manage-order-page')} />
            <ManageItemPage path={pagePath('manage-item-page')} />
            <SellerLink path={pagePath('seller-payment-link-page')} />

            {/* multiple items upload flow */}
            <UploadMultipleItems path={pagePath('upload-items-page')} />

            {/* token/buyer-first sale flow */}
            <BuyerSignupPage path={pagePath('buyer-signup-page')} />
            <BuyerRefPage path={pagePath('buyer-ref-page')} />
            <CreateTokenPage path={pagePath('create-offer-page')} />

            {/* new flow for seller to create item for sale */}
            <CreatePaymentLinkPage path={pagePath('create-new-payment-link-page')} />
            <StoreCreatedAddPhone path={pagePath('store-created-add-phone')} />

            <TokenPage path={pagePath('token-page')} />
            <TokenConfirmPage path={pagePath('token-confirm-page')} />
            <TokenLabelPage path={pagePath('token-label-page')} />

            <Referral path={pagePath('referral-page')} />
            <Complete path={pagePath('referral-complete')} />

            {/* item/token return */}
            <ReturnOrderPage path={pagePath('return-order-page')} />

            {/* seller partnership program */}
            <SPPOnboardLogin path={pagePath('seller-partnership-program-page')} />
            <SPPOnboardPartner path={pagePath('seller-partnership-program-onboard-page')} />
            <SPPOnboardSuccess path={pagePath('seller-partnership-program-onboard-success-page')} />
            <StoreView path={pagePath('seller-items-preview-page')} />
            <PartnerSellerPage path={pagePath('seller-items-page')} />
            <SPPOnboardSignup path={pagePath('seller-partnership-program-new-signup-page')} />
            <SPPOnboardSignupSuccess path={pagePath('seller-partnership-program-onboard-signup-success-page')} />
            <LearnMorePage path={pagePath('seller-partner-learn-more-page')} />
          </Router>
        </AppGrid>

        <Modal showModal={(!AppUser.isLoggedIn && loginRequired) || loginSignupVisible} onCancel={this.cancelLogin}>
          <LoginSignupDialog
            loginTitle={AppState.loginDialogProps.loginTitle || "Log in to your account"}
            signupTitle="Create an account"
            after={hideLoginSignup}
            showForm={loginSignupVisible}
            mseller={msellerLogin}
            loginButtonLabel={AppState.loginDialogProps.loginButtonLabel || "Log In"}
            signupButtonLabel={AppState.loginDialogProps.signupButtonLabel || "Sign Up"}
            showForgotPassword={undefined === AppState.loginDialogProps.showForgotPassword ? true : AppState.loginDialogProps.showForgotPassword}
            padded
          />
        </Modal>

        <Modal
          showModal={AppState.showConfirmationCode}
          onCancel={() => AppState.setShowConfirmationCode(false)}
          withCloseButton
        >
          <VerificationCodeDialog />
        </Modal>

        <Modal showModal={invalidSession}>
          <InvalidSessionNotice />
        </Modal>

        <PopupTextDisplay />
      </>
    );
  }
}

render(<PayOnDelivery />, document.getElementById('PayOnDelivery'));
